import { Form, type FormInstance } from "antd";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { CustomTypography } from "sipli-fleet-core/components";
import CustomerFormField from "../CustomerFormField";
import type { CustomerSelectLookups } from "../CustomerTabs";

const MainInformation = ({
  form: _form,
  selectLookups,
}: {
  form: FormInstance;
  selectLookups: CustomerSelectLookups;
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-8">
      <CustomTypography.CustomTitle className="!text-[17.72px] !font-bold">
        {t("main_information")}
      </CustomTypography.CustomTitle>

      <div className="mt-7">
        <CustomerFormField
          name="companyName"
          label={t("company_name")}
          placeholder={t("customer_form_type_placeholder")}
          className="!h-[32px] !rounded-[4px]"
          required
          rules={[
            { required: true, message: t("customer_form_company_required") },
          ]}
        />
        <div className="grid grid-cols-2 gap-x-2">
          <CustomerFormField
            name="clientType"
            label={t("customer_type")}
            placeholder={t("select")}
            className="!h-[32px] !rounded-[4px]"
            required
            rules={[
              { required: true, message: t("customer_form_type_required") },
            ]}
            options={selectLookups.clientTypeOptions}
            loading={selectLookups.clientTypeLoading}
          />
          <CustomerFormField
            name="state"
            label={t("state")}
            placeholder={t("select")}
            className="!h-[32px] !rounded-[4px]"
            options={selectLookups.clientStatusOptions}
            loading={selectLookups.clientStatusLoading}
          />
          <CustomerFormField
            name="email"
            label={t("customer_email")}
            placeholder={t("customer_form_type_placeholder")}
            className="!h-[32px] !rounded-[4px]"
            required
            type="email"
            rules={[
              { required: true, message: t("customer_form_email_required") },
              { type: "email", message: t("customer_form_email_invalid") },
            ]}
          />
          <CustomerFormField
            name="clientManager"
            label={t("custom_manager")}
            placeholder={t("select")}
            className="!h-[32px] !rounded-[4px]"
            options={selectLookups.clientPositionTypeOptions}
            loading={selectLookups.clientPositionTypeLoading}
          />
          <CustomerFormField
            name="language"
            label={t("language")}
            placeholder={t("select")}
            className="!h-[32px] !rounded-[4px]"
            options={selectLookups.languageOptions}
            loading={selectLookups.languageLoading}
          />
          <CustomerFormField
            name="country"
            label={t("country")}
            placeholder={t("select")}
            className="!h-[32px] !rounded-[4px]"
            options={selectLookups.customerCountryOptions}
            loading={selectLookups.customerCountryLoading}
          />
          {/* <CustomerFormField
            name="clientPreset"
            label={t("preset")}
            placeholder={t("select_preset")}
            className="!h-[32px] !rounded-[4px]"
            options={selectLookups.clientPresetOptions}
            loading={selectLookups.clientPresetLoading}
          />
          <CustomerFormField
            name="comment"
            label={t("comment")}
            placeholder={t("type")}
            className="!h-[32px] !rounded-[4px]"
          /> */}
        </div>

        <CustomTypography.CustomText className="!mt-5 !mb-4 !block !font-semibold !text-gray9">
          {t("contact_details")}
        </CustomTypography.CustomText>
        <div className="grid grid-cols-2 gap-x-2">
          <CustomerFormField
            name="name"
            label={t("name")}
            placeholder={t("customer_form_type_placeholder")}
            className="!h-[32px] !rounded-[4px]"
            required
            rules={[{ required: true, message: t("customer_form_name_required") }]}
          />
          <CustomerFormField
            name="surname"
            label={t("surname")}
            placeholder={t("customer_form_type_placeholder")}
            className="!h-[32px] !rounded-[4px]"
            required
            rules={[
              { required: true, message: t("customer_form_surname_required") },
            ]}
          />
          <Form.Item
            name="phoneNumber"
            label={t("phone_number")}
            rules={[
              { required: true, message: t("customer_form_phone_required") },
            ]}
            className="!mb-3 customer-form-item customer-phone-form-item"
          >
            <PhoneInput
              country="it"
              enableSearch
              placeholder={t("customer_form_type_placeholder")}
              containerClass="customer-phone-input"
              inputClass="customer-phone-input-field"
              buttonClass="customer-phone-input-button"
              dropdownClass="customer-phone-input-dropdown"
            />
          </Form.Item>
          <CustomerFormField
            name="contactEmail"
            label={t("email")}
            placeholder={t("customer_form_type_placeholder")}
            required
            type="email"
            className="!h-[32px] !rounded-[4px]"
            rules={[
              {
                required: true,
                message: t("customer_form_contact_email_required"),
              },
              { type: "email", message: t("customer_form_email_invalid") },
            ]}
          />
          <CustomerFormField
            name="positionType"
            label={t("type_of_position")}
            placeholder={t("select")}
            className="!h-[32px] !rounded-[4px]"
            formClassName="!mb-0"
            options={selectLookups.positionOptions}
            loading={selectLookups.positionLoading}
          />
          <CustomerFormField name="positionName" className="!h-[32px] !rounded-[4px]" formClassName="!mb-0" label={t("position_name")} placeholder={t("customer_form_type_placeholder")} />
        </div>
      </div>
    </div>
  );
};

export default MainInformation;
